import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { FiArrowUpRight } from 'react-icons/fi';
import { personalProjects } from '../data/projects';

const external = { target: '_blank', rel: 'noreferrer' };

function Projects() {
  return (
    <div className="page">
      <h2 className="section-title">My software projects...</h2>
      <div className="project-cards">
        {personalProjects.map((project) => (
          <article key={project.title} className="project-card">
            <header className="project-card__header">
              <div>
                <p className="project-card__eyebrow">{project.subtitle}</p>
                <h3 className="project-card__title">{project.title}</h3>
              </div>
              <a className="project-card__repo" href={project.href} {...external}>
                <FaGithub aria-hidden />
                <span>View code</span>
              </a>
            </header>

            <ul className="project-card__tools" aria-label="Tools used">
              {project.tools.map((tool) => (
                <li key={tool} className="pill">
                  {tool}
                </li>
              ))}
            </ul>

            <p className="project-card__context">{project.context}</p>

            <ul className="project-card__links">
              {project.links.map((link) => (
                <li key={link.label} className="project-link">
                  <a className="project-link__main" href={link.href} {...external}>
                    <span className="project-link__label">
                      {link.label}
                      <FiArrowUpRight aria-hidden />
                    </span>
                    {link.note && <span className="project-link__note">{link.note}</span>}
                  </a>
                  {link.extra && (
                    <span className="project-link__extras">
                      {link.extra.map((extra) => (
                        <a key={extra.href} className="pill pill--link" href={extra.href} {...external}>
                          {extra.label}
                          <FiArrowUpRight aria-hidden />
                        </a>
                      ))}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Projects;
